import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { EChartsOption } from 'echarts';
import * as echarts from 'echarts';
import { IVisitorBarGraph } from 'src/app/models/riskProfile';

@Component({
  selector: 'app-visitor-bar-graph',
  templateUrl: './visitor-bar-graph.component.html',
  styleUrl: './visitor-bar-graph.component.scss',
})
export class VisitorBarGraphComponent {
  chartOption: EChartsOption;
  height = '';
  hightestScore: number = 0;
  scoreTotal: number = 0;
  @ViewChild('echartsElement') echartsElement: ElementRef<HTMLInputElement>;
  myChart: any; // Define myChart variable
  @Input() set chartHeight(val: any) {
    if (val) this.height = val + 'px';
  }
  @Input() set chartData(val: IVisitorBarGraph[]) {
    if (val) {
      this.setGraph(val);
    }
  }
  setGraph(val: IVisitorBarGraph[]) {
    const formatDate = (date: Date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${day}-${month}-${year}`;
    };
    let dataAxis = val.map((item) => formatDate(new Date(item.inviteDate)));
    let data = val.map((item) =>
      item.visitorCount == 0 ? 0.1 : item.visitorCount
    );
    let yMax = Math.max(...val.map((x) => x.visitorCount));
    let dataShadow = [];

    for (let i = 0; i < data.length; i++) {
      dataShadow.push(yMax);
    }

    this.chartOption = {
      grid: {
        left: '10%',
        right: '2%',
        bottom: '10%',
        containLabel: false,
        width: '85%', // Adjust the width here
      },
      xAxis: {
        data: dataAxis,
        axisLabel: {
          inside: true,
          color: 'black',
          rotate: 90,
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        z: 10,
      },
      yAxis: {
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: '#999',
        },
      },
      dataZoom: [
        {
          type: 'inside',
        },
      ],
      series: [
        {
          type: 'bar',
          showBackground: true,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#83bff6' },
              { offset: 0.5, color: '#188df0' },
              { offset: 1, color: '#188df0' },
            ]),
          },
          emphasis: {
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#2378f7' },
                { offset: 0.7, color: '#2378f7' },
                { offset: 1, color: '#83bff6' },
              ]),
            },
          },
          data: data,
        },
      ],
    };
    if (this.myChart) {
      this.myChart.setOption(this.chartOption);
    }
    // Enable data zoom when user click bar.
    const zoomSize = 6;
    if (this.myChart)
      this.myChart.on('click', (params: any) => {
        this.myChart.dispatchAction({
          type: 'dataZoom',
          startValue: dataAxis[Math.max(params.dataIndex - zoomSize / 2, 0)],
          endValue:
            dataAxis[
              Math.min(params.dataIndex + zoomSize / 2, data.length - 1)
            ],
        });
      });
  }
}
